import { Component, Prop, Mixins } from "vue-property-decorator";
import RightsAware from '@/lib/mixins/rights-aware';

@Component
export default class XRadio extends Mixins(RightsAware) {

  @Prop({type: [Object, String, Number]}) readonly value!: any;
  @Prop() readonly data!: any[];

  @Prop({default: v => v, type: Function}) readonly labelFn!: Function;
  @Prop({default: v => v, type: Function}) readonly transform!: Function;
  @Prop({default: (a, b) => a === b}) readonly eqFn!: Function;

  onChange(e){
    let output = this.transform(e.target.value);
    this.$emit("change", output);
    this.$emit("input", output)
  }

  renderOptions(){
    return this.data.map( option => {
      return (
        <label class="radio">
          <input type="radio"  checked={this.eqFn(option, this.value)} value={option} onChange={this.onChange}/> {this.labelFn(option)}
        </label>
      )
    });
  }

  render() {
    return (
      <div>
        {this.renderOptions()}
      </div>
    );
  }

}


// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-9084cd90/x-radio.tsx" });